module.exports = __webpack_public_path__ + "img/openBg.beed03c3.jpg";